import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Label,
    Button,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"
import apiResponse from '../../../../services/apiResponse'
import CreateBloc from './Blocs/CreateBloc'
import { accessRole } from "../../../../helpers/access_role"
import CustomSelect from '../../../../helpers/ui/CustomSelect'
import moment from 'moment'


class IndexView extends Component {

    createBloc = new CreateBloc();
    queryParams = new URLSearchParams(window.location.search)

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {
                nip: "",
                nama: "",
                no_sk_lama: "",
                tanggal_sk_lama: "",
                kgb_temp_gaji_pokok_lama: "",
                kgb_temp_gaji_pokok_baru: "",
                tmt_jabatan: "",
                golongan: "",
                tgl_lahir: "",
                jenis_kelamin: "",
                employee_front_title: "",
                employee_end_title: "",
                kgb_temp_masa_kerja_tahun: "",
                kgb_temp_masa_kerja_bulan: "",
                kgb_temp_masa_kerja_tahun_lama: "",
                kgb_temp_masa_kerja_bulan_lama: "",
                employee_current_rank_uuid: "",
            },
            employeeItems: [],
            employeeSelected: "",
            salary: null,
            loading: true,
        }
    }
    dateParseYMD = (input) => {
        let res = "";
        if (input != "" && input != null) {
            res = moment(input).format('DD-MM-YYYY')
        }
        return res;
    }
    reformatEmployee = (data) => {
        return data.map(function (item) {
            var newObj = {};
            newObj["label"] = item.kgb_temp_employee_nip + " - " + item.kgb_temp_employee_name;
            newObj["value"] = item.kgb_temp_employee_uuid;
            newObj["model"] = item;
            return newObj;
        });
    };

    reformatOptions = (raw, label, value) => {
        return raw.map(function (data) {
            var newObj = {};
            newObj["label"] = data[label];
            newObj["value"] = data[value];

            return newObj;
        });
    };

    dateParse = (input) => {
        let res = "";
        if (input != "" && input != null) {
            res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    rupiah = (num) => {
        let res = "-";
        if (num != null && num != '') {
            res = parseFloat(num).toLocaleString('id-ID', { maximumFractionDigits: 2 })
        }
        return res;
    }

    submitData = async () => {
        const formData = generateFormData(this.state.dataForm, '') // 'document' disini adalah nama field FileInput. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto'] 
        await this.createBloc.fetchCreate(formData)
        console.log(formData)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                ...values,
                kgb_period_uuid: this.queryParams.get('period_uuid')
            },
            confirm: true
        })
    }

    onChangeEmployee = (employee) => {
        var model = employee.model
        this.setState({
            employeeSelected: employee.value,
            dataForm: {
                nip: model.kgb_temp_employee_nip,
                nama: model.kgb_temp_employee_name,
                no_sk_lama: model.kgb_temp_sk_lama,
                tanggal_sk_lama: this.dateParseYMD(model.kgb_temp_tanggal_sk_lama),
                kgb_temp_gaji_pokok_lama: model.kgb_temp_gaji_pokok_lama,
                kgb_temp_gaji_pokok_baru: model.kgb_temp_gaji_pokok_baru,
                tmt_jabatan: model.employee_current_tmt_position,
                golongan: model.kgb_temp_golongan_ruang,
                tgl_lahir: model.kgb_temp_tempat_lahir + ', ' + this.dateParseYMD(model.kgb_temp_tanggal_lahir),
                jenis_kelamin: model.employee_gender_name,
                employee_front_title: model.employee_front_title,
                employee_end_title: model.employee_end_title,
                kgb_temp_masa_kerja_tahun: model.kgb_temp_masa_kerja_tahun,
                kgb_temp_masa_kerja_bulan: model.kgb_temp_masa_kerja_bulan,
                kgb_temp_masa_kerja_tahun_lama: model.kgb_temp_masa_kerja_tahun_lama,
                kgb_temp_masa_kerja_bulan_lama: model.kgb_temp_masa_kerja_bulan_lama,
                employee_current_rank_uuid: model.employee_current_rank_uuid
            }
        })

        // // get gaji
        // this.createBloc.fetchSalary({
        //     rank_uuid: model.employee_current_rank_uuid,
        //     years_of_work: model.masa_kerja_tahun
        // })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }
    formatRupiahOnChange = (e) => {
        let value = e.target.value;
        // Hapus semua karakter non-digit
        value = value.replace(/\D/g, '');
        // Format ulang dengan separator ribuan
        value = new Intl.NumberFormat('id-ID').format(value);
        e.target.value = value;
    }

    handleGajiLamaChange = (e) => {
        this.formatRupiahOnChange(e);
        // Update state jika diperlukan
        this.setState({
            dataForm: {
                ...this.state.dataForm,
                kgb_temp_gaji_pokok_lama: e.target.value.replace(/\./g, '')
            }
        });
    }

    handleGajiBaruChange = (e) => {
        this.formatRupiahOnChange(e);
        // Update state jika diperlukan
        this.setState({
            dataForm: {
                ...this.state.dataForm,
                kgb_temp_gaji_pokok_baru: e.target.value.replace(/\./g, '')
            }
        });
    }

    componentDidMount() {

        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.createBloc.employeeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        this.setState({
                            loading: false,
                            employeeItems: this.reformatEmployee(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })

        this.createBloc.salaryChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        this.setState({
                            salary: response
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })

        this.createBloc.fetchEmployee({
            kgb_period_uuid: this.queryParams.get('period_uuid')
        })
    }

    componentWillUnmount() {
        this.createBloc.createChannel.unsubscribe()
        this.createBloc.employeeChannel.unsubscribe()
        this.createBloc.salaryChannel.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card className="">
                                <CardBody>
                                    <CardTitle>Tambah Manual Kenaikan Gaji Berkala</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                Pilih Pegawai <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <Select
                                                    value={this.state.employeeItems.filter(option =>
                                                        option.value === this.state.employeeSelected)}
                                                    onChange={
                                                        this.onChangeEmployee
                                                    }
                                                    required="required"
                                                    options={this.state.employeeItems}
                                                    classNamePrefix=""
                                                    placeholder="Pilih Pegawai"
                                                />
                                                <AvField
                                                    name="kgb_employee_uuid"
                                                    type="hidden"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="kgb_employee_uuid"
                                                    value={this.state.employeeSelected}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                NIP
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    placeholder=""
                                                    name="nip"
                                                    id="nip"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.nip}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                Nama
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    placeholder=""
                                                    name="nama"
                                                    id="nama"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.nama}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                Tempat/Tanggal Lahir
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    placeholder=""
                                                    name="unit_kerja"
                                                    id="unit_kerja"
                                                    readonly="readonly"
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.dataForm.tgl_lahir}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                Pangkat (Gol./Ruang)
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    placeholder=""
                                                    name="golongan"
                                                    id="golongan"
                                                    readonly="readonly"
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.dataForm.golongan}
                                                />
                                                <AvField
                                                    placeholder=""
                                                    name="employee_current_rank_uuid"
                                                    id="employee_current_rank_uuid"
                                                    readonly="readonly"
                                                    type="hidden"
                                                    className="form-control"
                                                    value={this.state.dataForm.employee_current_rank_uuid}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                Nomor SK Lama
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    placeholder=""
                                                    name="no_sk_lama"
                                                    id="no_sk_lama"
                                                    // readonly="readonly"
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.dataForm.no_sk_lama}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                Tanggal SK Lama
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    placeholder=""
                                                    name="tanggal_sk_lama"
                                                    id="tanggal_sk_lama"
                                                    // readonly="readonly"
                                                    type="date"
                                                    className="form-control"
                                                    value={this.state.dataForm.tanggal_sk_lama ? this.state.dataForm.tanggal_sk_lama.split("-").reverse().join("-") : ""}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                Masa Kerja Lama (Tahun, Bulan)
                                            </label>
                                            <Col md="1">
                                                <AvField
                                                    placeholder=""
                                                    name="kgb_temp_masa_kerja_tahun_lama"
                                                    id="kgb_temp_masa_kerja_tahun_lama"
                                                    // readonly="readonly"
                                                    type="text"
                                                    className="form-control"
                                                    value={`${this.state.dataForm.kgb_temp_masa_kerja_tahun_lama ?? 0}`}
                                                />
                                            </Col>
                                            <Col md="1">
                                                <AvField
                                                    placeholder=""
                                                    name="kgb_temp_masa_kerja_bulan_lama"
                                                    id="kgb_temp_masa_kerja_bulan_lama"
                                                    // readonly="readonly"
                                                    type="text"
                                                    className="form-control"
                                                    value={`${this.state.dataForm.kgb_temp_masa_kerja_bulan_lama ?? 0}`}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                Gaji Lama
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    placeholder=""
                                                    name="gaji_lama"
                                                    id="gaji_lama"
                                                    // readonly="readonly"
                                                    onChange={this.handleGajiLamaChange}
                                                    type="text"
                                                    className="form-control"
                                                    value={`${this.rupiah(this.state.dataForm.kgb_temp_gaji_pokok_lama)}`}
                                                />
                                            </Col>
                                        </Row>



                                        <hr />
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                Masa Kerja Baru (Tahun, Bulan)
                                            </label>
                                            <Col md="1">
                                                <AvField
                                                    placeholder=""
                                                    name="kgb_temp_masa_kerja_tahun"
                                                    id="kgb_temp_masa_kerja_tahun"
                                                    // readonly="readonly"
                                                    type="text"
                                                    className="form-control"
                                                    value={`${this.state.dataForm.kgb_temp_masa_kerja_tahun ?? 0}`}
                                                />
                                            </Col>
                                            <Col md="1">
                                                <AvField
                                                    placeholder=""
                                                    name="kgb_temp_masa_kerja_bulan"
                                                    id="kgb_temp_masa_kerja_bulan"
                                                    // readonly="readonly"
                                                    type="text"
                                                    className="form-control"
                                                    value={`${this.state.dataForm.kgb_temp_masa_kerja_bulan ?? 0}`}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                Gaji Berdasarkan Pangkat dan Masa Kerja
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    placeholder=""
                                                    name="kgb_salary_value"
                                                    id="kgb_salary_value"
                                                    // readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={`${this.rupiah(this.state.dataForm.kgb_temp_gaji_pokok_baru)}`}
                                                    onChange={this.handleGajiBaruChange}
                                                />
                                            </Col>
                                        </Row>

                                        <hr />

                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to={`/kepegawaian/kgb.html?pegawai&uuid=${this.queryParams.get('period_uuid')}`}>
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Pengambilan data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                {this.state.redirect ?
                    <Redirect to={`/kepegawaian/kgb.html?pegawai&uuid=${this.queryParams.get('period_uuid')}`} />
                    : null}
            </Fragment>
        )
    }

}

export default IndexView